import { createSelector } from 'reselect';
import TableDefinitions from '../../../../common/TableDefinitions';
import DailyRouteLeadingCountStatusListColumns from '../../containers/DailyRouteLeadingCountStatusListColumns';
import { getAvg, getTotal } from '../../../react-table/helpers/calculateTotal';
import DailyRouteLeadingCountStatusListTotalColumns from '../../containers/DailyRouteLeadingCountStatusListTotalColumns';
import DailyRouteLeadingCountStatusListEDIRFIDColumns from '../../containers/DailyRouteLeadingCountStatusListEDIRFIDColumns';

export const getIsLoading = (state) => state.listing.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.isLoading;
export const getData = TableDefinitions.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.getDataFunction();
export const getFilteredData = (state) => state.listing.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.filteredData;
export const getColumns = createSelector(getData, DailyRouteLeadingCountStatusListColumns);
export const getTotalData = createSelector(
  getData,
  (data) => {
    if (!data.length) {
      return [];
    }
    return [
      { name: 'Total', ...getTotal(data) },
      { name: 'Avg', ...getAvg(data) },
    ];
  },
);
export const getTotalFilteredData = createSelector(
  (state) => state.listing.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.filteredData,
  (data) => [
    { name: 'Total', ...getTotal(data) },
    { name: 'Avg', ...getAvg(data) },
  ],
);
export const getTotalColumns = createSelector(getData, DailyRouteLeadingCountStatusListTotalColumns);

export const getEDIRFIDColumns = createSelector(getData, DailyRouteLeadingCountStatusListEDIRFIDColumns);

export const getEDIRFIDData = createSelector(
  getData,
  (data) => {
    let ediUsed = 0;
    let rfidUsed = 0;

    if (!data.length) {
      return [];
    }

    data.forEach((d) => {
      switch (d.dailyRouteLeadingCountStatus) {
        case 'EDI':
        case 'EDI_DAY':
        case 'MAX_EDI_DAY':
        case 'MAX_EDI':
          ediUsed += 1;
          break;
        case 'MAX_RFID_DAY':
        case 'MAX_RFID':
          rfidUsed += 1;
          break;
        default:
      }
    });

    return [
      { name: 'Num of Times EDI used', used: ediUsed },
      { name: 'Num of Times RFID used', used: rfidUsed },
    ];
  },
);

export const getTotalFilteredEDIRFIDData = createSelector(
  (state) => state.listing.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.filteredData,
  (data) => {
    let ediUsed = 0;
    let rfidUsed = 0;

    if (!data.length) {
      return [];
    }

    data.forEach((d) => {
      switch (d.dailyRouteLeadingCountStatus) {
      case 'EDI':
      case 'EDI_DAY':
      case 'MAX_EDI_DAY':
      case 'MAX_EDI':
        ediUsed += 1;
        break;
      case 'MAX_RFID_DAY':
      case 'MAX_RFID':
        rfidUsed += 1;
        break;
      default:
      }
    });

    return [
      { name: 'Num of Times EDI used', used: ediUsed },
      { name: 'Num of Times RFID used', used: rfidUsed },
    ];
  },
);
